import { createAction } from '@reduxjs/toolkit'

import type { Member } from 'types'

interface FetchOrganizationMembersPayload {
    members: Member[]
    organizationId: string
}

interface FetchOrganizationGroupMembersPayload {
    members: Member[]
    organizationGroupId: string
}

// fetch organization members
export const fetchOrganizationMembersSuccess =
    createAction<FetchOrganizationMembersPayload>(
        'FETCH_ORGANIZATION_MEMBERS_SUCCESS'
    )

// fetch organization group members
export const fetchOrganizationGroupMembersSuccess =
    createAction<FetchOrganizationGroupMembersPayload>(
        'FETCH_ORGANIZATION_GROUP_MEMBERS_SUCCESS'
    )
